import {
  SiteVisitLog,
  CreateSiteVisitLogRequest,
  UpdateSiteVisitLogRequest,
} from '../models/SiteVisitLog';
import { API_ENDPOINTS } from '../config/api';
import { apiClient } from './api/apiClient';
import {
  ApiItemResponse,
  ApiListResponse,
  ApiOkResponse,
  ensureOk,
  unwrapItem,
  unwrapList,
} from './api/response';

export class SiteVisitLogService {
  static async list(projectId: number): Promise<SiteVisitLog[]> {
    const response = await apiClient.get<ApiListResponse<SiteVisitLog>>(
      API_ENDPOINTS.SITE_MANAGEMENT.VISIT_LOGS.LIST(projectId),
    );
    return unwrapList(response, '출장 일지 목록 조회 실패');
  }

  static async get(logId: number): Promise<SiteVisitLog> {
    const response = await apiClient.get<ApiItemResponse<SiteVisitLog>>(
      API_ENDPOINTS.SITE_MANAGEMENT.VISIT_LOGS.GET(logId),
    );
    return unwrapItem(response, '출장 일지 조회 실패');
  }

  static async create(projectId: number, data: CreateSiteVisitLogRequest): Promise<SiteVisitLog> {
    const response = await apiClient.post<ApiItemResponse<SiteVisitLog>>(
      API_ENDPOINTS.SITE_MANAGEMENT.VISIT_LOGS.CREATE(projectId),
      data,
    );
    return unwrapItem(response, '출장 일지 생성 실패');
  }

  static async update(logId: number, data: UpdateSiteVisitLogRequest): Promise<SiteVisitLog> {
    const response = await apiClient.put<ApiItemResponse<SiteVisitLog>>(
      API_ENDPOINTS.SITE_MANAGEMENT.VISIT_LOGS.UPDATE(logId),
      data,
    );
    return unwrapItem(response, '출장 일지 수정 실패');
  }

  static async delete(logId: number): Promise<void> {
    const response = await apiClient.delete<ApiOkResponse>(
      API_ENDPOINTS.SITE_MANAGEMENT.VISIT_LOGS.DELETE(logId),
    );
    ensureOk(response, '출장 일지 삭제 실패');
  }
}
